import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class FormEntryInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dirty: false,
      valid: null,
      active: false,
      first: true,
    }
  }

  componentDidMount() {
    if (
      this.props.skipValidation &&
      this.props.format &&
      this.props.defaultValue &&
      this.props.isValid
    ) {
      if (new RegExp(this.props.format.regex).test(this.props.defaultValue)) {
        this.props.isValid({ key: this.props.fieldName, valid: true })
      }
    }
  }

  test(e, format, valid) {
    let check = null

    if (valid) {
      e.preventDefault()
      check = true
    } else if (e.target.value && format.regex) {
      e.preventDefault()
      check = new RegExp(format.regex).test(e.target.value)
    } else {
      check = false
    }
    this.setState({ dirty: true })
    this.setState({ valid: check }, () => {
      if (this.props.isValid) {
        this.props.isValid({ key: this.props.fieldName, valid: check })
      }
    })
  }

  inputStateStyle() {
    let style = null

    if (this.state.dirty && !this.state.valid && !this.state.active) {
      style = midas.hasDanger
    } else if (
      this.state.dirty &&
      !this.state.valid &&
      !this.state.first &&
      this.state.active
    ) {
      style = midas.hasWarning
    } else if (this.state.dirty && this.state.valid) {
      style = midas.hasSuccess
    }
    return `${midas.formGroup} ${style}`
  }

  formInputAndsize() {
    const size = this.props.size
    let inputSize = null

    if (size === 'xl') {
      inputSize = midas.inputXl
    } else if (size === 'lg') {
      inputSize = midas.inputLg
    } else if (size === 'sm') {
      inputSize = midas.inputSm
    }
    return `${midas.formInput} ${size && inputSize}`
  }

  render() {
    return (
      <div className={this.inputStateStyle()}>
        <label className={midas.formLabel} htmlFor={this.props.fieldName}>
          {this.props.fieldCaption}
        </label>
        <input
          className={this.formInputAndsize()}
          id={this.props.fieldName}
          placeholder={this.props.fieldPlaceholder}
          type={this.props.type}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onTouchEnd={e =>
            setTimeout(() => {
              this.test(e, this.props.format, this.props.skipValidation)
            }, 100)
          }
          onKeyUp={e =>
            this.test(e, this.props.format, this.props.skipValidation)
          }
          onFocus={() => this.setState({ active: true })}
          onBlur={() => this.setState({ active: false, first: false })}
          readOnly={this.props.readonly}
        />
        {this.state.dirty &&
          !this.state.valid &&
          !this.state.active && (
            <span className={midas.formInputHint}>
              {this.props.format.error}
            </span>
          )}
      </div>
    )
  }
}

FormEntryInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string,
  fieldPlaceholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
  format: PropTypes.object,
  isValid: PropTypes.func,
  skipValidation: PropTypes.bool,
}

FormEntryInput.defaultProps = {
  defaultValue: null,
  readonly: false,
  onChange: null,
  format: null,
  isValid: null,
  size: null,
  fieldPlaceholder: null,
  fieldCaption: null,
  skipValidation: false,
}
